import React, { useEffect, useRef, useState } from 'react';

const TextContent = ({ textContent, highlightedIndex, isAudioPlaying, isScrubbing }) => {
  const textContainerRef = useRef(null);
  const scrollTimeoutRef = useRef(null);
  const [isUserScrolling, setIsUserScrolling] = useState(false);

  // Handle user scroll and delay auto-scroll
  useEffect(() => {
    const handleScroll = () => {
      setIsUserScrolling(true);
      clearTimeout(scrollTimeoutRef.current);
      scrollTimeoutRef.current = setTimeout(() => {
        setIsUserScrolling(false);
      }, 500);
    };

    const container = textContainerRef.current;
    container.addEventListener('scroll', handleScroll);

    return () => {
      container.removeEventListener('scroll', handleScroll);
      clearTimeout(scrollTimeoutRef.current);
    };
  }, []);

  // Auto-scroll only if audio is playing or scrubbing, and user isn't manually scrolling
  useEffect(() => {
    if ((isAudioPlaying || isScrubbing) && highlightedIndex !== null && !isUserScrolling && textContainerRef.current) {
      const highlightedElement = document.getElementById(`word-${highlightedIndex}`);
      if (highlightedElement) {
        highlightedElement.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
      }
    }
  }, [highlightedIndex, isAudioPlaying, isScrubbing, isUserScrolling]); // Trigger when index, audio playing, or scrubbing changes
  

  // Function to wrap each word in a span element with highlighting
  const getHighlightedText = (text) => {
    const words = text.split(' ');
    return words.map((word, index) => {
      const isHighlighted = index === highlightedIndex; // Highlight based on index
      return (
        <span
          key={index}
          id={`word-${index}`} // Unique ID for scrolling
          className={isHighlighted ? 'highlight' : ''}
        >
          {word}{' '}
        </span>
      );
    });
  };

  return (
    <div id="text-content" ref={textContainerRef}>
      {getHighlightedText(textContent)} {/* Render highlighted text */}
    </div>
  );
};

export default TextContent;